import { MaybeRefOrGetter, Ref, ref, toRef } from "vue";
import { IDialogueConfig, ISentence } from "./types";
import { ComputedRefWithControl, computedWithControl } from "@vueuse/core";
import { getDisplayTextByRows } from "@/modules/split";

export enum ClampStrategyEnum {
  Character = "character",
}

/**
 * FIXME: 这里只支持中文内容，英文不应该根据字符拆分
 */
export type StrategyConfig = {
  strategy: ClampStrategyEnum;
  maxCharacterCount: number;
};

export const useTextClamp = (
  text: string,
  strategyConfig: StrategyConfig
): string[] => {
  if (strategyConfig.strategy === ClampStrategyEnum.Character) {
    // 将text根据maxCharacterCount进行分段
    const segments = [];
    for (let i = 0; i < text.length; i += strategyConfig.maxCharacterCount) {
      segments.push(text.slice(i, i + strategyConfig.maxCharacterCount));
    }
    return segments;
  }

  return [];
};

export const useSentencesClampByRow = (
  configRef: Ref<IDialogueConfig>,
  rows: number = 3,
  element: MaybeRefOrGetter<HTMLElement | null>,
  mockElementId: string = "game-dialogue-compute"
): ComputedRefWithControl<IDialogueConfig> => {
  const elementRef = toRef(element);
  const clampedConfigRef = computedWithControl<
    IDialogueConfig,
    IDialogueConfig
  >(configRef, () => {
    const sentences = configRef.value.sentences;
    const clampedSentences = sentences.reduce(
      (acc: ISentence[], sentence: ISentence) => {
        const { content } = sentence;
        const chunks = content
          ? splitTextToChunks(rows, content, elementRef, mockElementId)
          : [content];
        return [
          ...acc,
          ...(chunks?.map((chunk) => ({ ...sentence, content: chunk })) || []),
        ];
      },
      []
    );
    return {
      ...configRef.value,
      sentences: clampedSentences,
    } as IDialogueConfig;
  });
  return clampedConfigRef;
};

const splitTextToChunks = (
  rows: number,
  text: string,
  elementRef: Ref<HTMLElement | null>,
  mockElementId: string
) => {
  const chunks: string[] = [];
  let restText = text;
  while (restText.length > 0) {
    const result = getDisplayTextByRows(
      rows,
      elementRef,
      mockElementId,
      restText
    );

    if (!result) return null;
    chunks.push(result.text);
    restText = restText.slice(result.text.length);
  }
  return chunks;
};
